import { useSearchParams } from 'react-router'
import { TokenExpiredPage } from '../tokenExpired/TokenExpiredPage'
import { RegistrationPage } from './RegistrationPage'
import { useApiVerifyEmail } from '../../api/account/apiUsers'
import { CenteredSpinner } from '../../genericComponents/Spinner'
import { useEffect } from 'react'

export const VerifyEmail = () => {
  const [params] = useSearchParams()

  const token = params.get('token')
  const { isError, isSuccess, mutate } = useApiVerifyEmail()
  useEffect(() => {
    mutate(token as string)
  }, [])
  console.log('isSuccess', isSuccess)
  console.log('isError', isError)

  return isSuccess ? <RegistrationPage /> : isError ? <TokenExpiredPage /> : <CenteredSpinner />
}
